<template>
    <div class="">
        <transition name="slide">
            <MegamenuList
                v-if="activeItem"
                :node="activeItem"
                class="absolute top-0 bg-white"
                :class="activeItem.children.length > 9 && '-ml-96 pl-32 w-max-content'"
                closable
                @close="activeItem = null"
            />
        </transition>
        <div :class="activeItem && 'opacity-0 z-negative pointer-events-none'">
            <button
                v-if="closable"
                class="relative mb-3 flex text-blue-500 items-center justify-between px-3 py-1 cursor-pointer hover:bg-blue-100"
                :aria-label="node.title + ' close menu'"
                style="width: 260px;"
                ref="backButton"
                @click="$emit('close')"
            >
                {{ node.title }}
                <!-- prettier-ignore -->
                <svg width="20" height="20" role="img" focusable="false" aria-label="" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.9502 13.8891L13.8895 14.9497L5.05067 6.11091L6.11133 5.05025L14.9502 13.8891Z" fill="#004876"/>
                    <path d="M14.9493 6.11091L6.1105 14.9497L5.04984 13.8891L13.8887 5.05025L14.9493 6.11091Z" fill="#004876"/>
                </svg>
            </button>
            <ul
                class="text-blue-500 transition-opacity duration-300"
                :class="closable && node.children.length > 9 && 'columns-2'"
            >
                <li
                    v-for="child in node.children"
                    :key="child.title"
                    class="flex items-center justify-between w-64 cursor-pointer hover:bg-blue-100"
                >
                    <a
                        :href="child.url"
                        :class="activeItem && 'opacity-0'"
                        class="py-1 pl-3 flex-grow"
                        @click="child.children.length && activate(child)"
                        @focus="activeItem = null"
                        >{{ child.title }}</a
                    >

                    <template v-if="child.children.length">
                        <button
                            class="flex items-center self-stretch justify-center px-2"
                            aria-has-popup="true"
                            aria-expanded="false"
                            :aria-label="child.title + ' menu'"
                            @click="activate(child)"
                            @focus="activeItem = null"
                        >
                            <!-- prettier-ignore -->
                            <svg class="transform -rotate-90" role="img" focusable="false" aria-label="" width="11" height="6" viewbox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.8675 3.89223L1.77622 0.0241611L0.760306 1.04123L5.84334 6L11 1.06654L9.93346 0L5.8675 3.89223Z" fill="currentColor"/>
                            </svg>
                        </button>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import MegamenuList from './MegamenuList.vue';

export default {
    name: 'MegamenuList',
    data: () => ({
        activeItem: null
    }),
    props: {
        node: {
            type: Object,
            required: true
        },
        closable: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        activate(node) {
            this.activeItem = node;
        }
    },
    components: { MegamenuList },
    mounted() {
        if (this.closable) {
            this.$refs.backButton.focus();
        }
    }
};
</script>
<style>
.columns-2 {
    columns: 2;
}
</style>
